var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "coopba-topbar" }, [
    _c("span", [_vm._v("Bachillerato de Bellas Artes — UNLP")]),
    _vm._v(" "),
    _c(
      "span",
      [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.bba.unlp.edu.ar",
              target: "_blank",
              rel: "noopener",
            },
          },
          [_vm._v("bba.unlp.edu.ar")]
        ),
        _vm._v("\n     | \n    "),
        _c(
          "router-link",
          { attrs: { to: { path: "/", query: { seccion: "contacto" } } } },
          [_vm._v("Contacto")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }